import axios from "axios";
import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const baseURL = "";
// const baseURL = process.env.SERVER_API_URL;
//const baseURL = location.hostname === "localhost" || location.hostname === "127.0.0.1" ? "http://localhost:10005" : "";
//const baseURL = "https://baocaodieuhanh.vnta.gov.vn";
//const baseURL = "https://qltp.adfilex.vn";
export default class UserAdministratorService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

  public SearchUser(queryForm: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseURL + `/api/auth/users/search`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getUserName(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseURL + `/api/auth/users/usernames`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getFullName(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseURL + `/api/auth/users/full_names`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getPhoneNumber(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseURL + `/api/auth/users/phone_numbers`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Delete User
  public deleteUsers(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(baseURL + `/api/auth/users/${id}/delete`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
